const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                context.set('_parent', context.clone());

                (() => {
                    let c = this.ensureTraversable(this.createRange(0, 2));

                    if (c === context) {
                        context.set('_seq', context.clone());
                    }
                    else {
                        context.set('_seq', c);
                    }
                })();

                context.set('loop', new Map([
                  ['parent', context.get('_parent')],
                  ['index0', 0],
                  ['index', 1],
                  ['first', true]
                ]));
                if ((typeof context.get('_seq') === 'object') && this.isCountable(context.get('_seq'))) {
                    let length = this.count(context.get('_seq'));
                    let loop = context.get('loop');
                    loop.set('revindex0', length - 1);
                    loop.set('revindex', length);
                    loop.set('length', length);
                    loop.set('last', (length === 1));
                }
                this.iterate(context.get('_seq'), (__key__, __value__) => {
                    context.proxy[`_key`] = __key__;
                    context.proxy[`i`] = __value__;
                    this.echo(`  `);
                    this.echo(this.include(context, this.source, `@cloudfour/objects/hype-group/demo/single.twig`, new Map([[`container_class`, this.env.getFunction('cycle').traceableCallable(3, this.source)(...[new Map([[0, `o-container--pad`], [1, `o-container--pad t-alternate`]]), this.traceableMethod(this.getAttribute, 3, this.source)(this.env, context.get(`loop`), `index0`, new Map([]), `any`, false, false, false)])], [`reverse`, this.env.getFunction('cycle').traceableCallable(4, this.source)(...[new Map([[0, (context.has(`reverse`) ? context.get(`reverse`) : null)], [1,  !(context.has(`reverse`) ? context.get(`reverse`) : null)]]), this.traceableMethod(this.getAttribute, 4, this.source)(this.env, context.get(`loop`), `index0`, new Map([]), `any`, false, false, false)])]]), true, false, 2));
                    (() => {
                        let loop = context.get('loop');
                        loop.set('index0', loop.get('index0') + 1);
                        loop.set('index', loop.get('index') + 1);
                        loop.set('first', false);
                        if (loop.has('length')) {
                            loop.set('revindex0', loop.get('revindex0') - 1);
                            loop.set('revindex', loop.get('revindex') - 1);
                            loop.set('last', loop.get('revindex0') === 0);
                        }
                    })();
                });
                (() => {
                    let parent = context.get('_parent');
                    context.delete('_seq');
                    context.delete('_iterated');
                    context.delete('_key');
                    context.delete('i');
                    context.delete('_parent');
                    context.delete('loop');
                    for (let [k, v] of parent) {
                        if (!context.has(k)) {
                            context.set(k, v);
                        }
                    }
                })();
            }

            getTemplateName() {
                return `4b25aa2e74551be660bfc04ad31f71fd921387fa87b48b4c7c5767dc618d28d6`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `4b25aa2e74551be660bfc04ad31f71fd921387fa87b48b4c7c5767dc618d28d6`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, '4b25aa2e74551be660bfc04ad31f71fd921387fa87b48b4c7c5767dc618d28d6');

let template = env.loadTemplate('4b25aa2e74551be660bfc04ad31f71fd921387fa87b48b4c7c5767dc618d28d6');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/objects/hype-group/demo/multiple.twig", args: context }
     );
     return rendered;;
};